import { useTranslation } from 'react-i18next';
import { Documentation } from 'graphql-common';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
// import Chip, { ChipTypes } from '@lib/components/Chip/Chip';
// import Collapse from '@lib/components/Collapse/Collapse';
import DocumentationPreview from '@lib/components/DocumentationPreview/DocumentationPreview';
import { DocumentationPreviewEnum } from '@lib/components/DocumentationPreview/enums';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import TextEditor from '@lib/components/TextEditor/TextEditor';
import { hasTextEditorValue } from '@lib/components/TextEditor/utils';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import DocumentInfo from './DocumentInfo';

type Props = {
  data: Documentation;
  isViewLocked: boolean;
  onViewFile: () => void;
};

export default function DocumentDetails({
  data,
  isViewLocked,
  onViewFile,
}: Props) {
  const { t } = useTranslation();
  const { description, currentVersion } = data;

  return (
    <>
      <DocumentInfo data={data} isViewLocked={isViewLocked} />

      {hasTextEditorValue(description) && (
        <div className={entityViewStyles.infoItemCol}>
          <p className={entityViewStyles.infoItemTitle}>
            <MaterialIcon icon="description" symbolsOutlined />
            <Typography variant="caption">{t('description')}</Typography>
          </p>
          <div className={entityViewStyles.infoItemContent}>
            <TextEditor
              readOnly
              value={description}
              className={entityViewStyles.textEditor}
            />
          </div>
        </div>
      )}

      <div className={entityViewStyles.infoItemCol}>
        <p className={entityViewStyles.infoItemTitle}>
          <MaterialIcon icon="attach_file" symbolsOutlined />
          <Typography variant="caption">{t('attachment')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          {currentVersion?.attachmentAttached ? (
            <DocumentationPreview
              attachment={currentVersion.attachmentAttached}
              notes={currentVersion.notes || undefined}
              view={DocumentationPreviewEnum.DocumentRowCard}
              onClick={onViewFile}
              actions={
                <IconButton
                  icon="visibility"
                  symbolsOutlined
                  type={IconButtonTypes.PrimaryOutlined}
                  onClick={onViewFile}
                />
              }
            />
          ) : (
            <Typography variant="body">-</Typography>
          )}
        </div>
      </div>

      {/* {!!(tags && tags.length > 0) && (
        <div className={entityViewStyles.infoItemCol}>
          <p className={entityViewStyles.infoItemTitle}>
            <MaterialIcon icon="tag" symbolsOutlined />
            <Typography variant="caption">{t('tags')}</Typography>
          </p>
          <div className={entityViewStyles.infoItemContent}>
            <Collapse minHeight={56}>
              <div className={entityViewStyles.infoItemContentRow}>
                {tags.map((tag) => (
                  <Chip
                    key={tag.id}
                    type={ChipTypes.chipGray}
                    label={tag.name}
                  />
                ))}
              </div>
            </Collapse>
          </div>
        </div>
      )} */}
    </>
  );
}
